var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    { ref: "popover", attrs: { width: "400", trigger: "click" } },
    [
      _c(
        "el-row",
        [
          _c(
            "el-form",
            { ref: "form", attrs: { size: "mini", "label-width": "70px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("panel.auto_play") } },
                [
                  _c("el-switch", {
                    attrs: { size: "mini" },
                    model: {
                      value:
                        _vm.linkInfoTemp[_vm.linkInfoTemp.videoType].autoplay,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.linkInfoTemp[_vm.linkInfoTemp.videoType],
                          "autoplay",
                          $$v
                        )
                      },
                      expression:
                        "linkInfoTemp[linkInfoTemp.videoType].autoplay",
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "#909399",
                        "font-size": "8px",
                        "margin-left": "3px",
                      },
                    },
                    [
                      _vm._v(
                        "\n          Tips:" +
                          _vm._s(_vm.$t("panel.video_tips")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm.linkInfoTemp.videoType === "web"
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("panel.play_frequency") } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value:
                              _vm.linkInfoTemp[_vm.linkInfoTemp.videoType].loop,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.linkInfoTemp[_vm.linkInfoTemp.videoType],
                                "loop",
                                $$v
                              )
                            },
                            expression:
                              "linkInfoTemp[linkInfoTemp.videoType].loop",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v(_vm._s(_vm.$t("panel.play_once"))),
                          ]),
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v(_vm._s(_vm.$t("panel.play_circle"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("panel.video_links") } },
                [
                  _c("el-input", {
                    model: {
                      value:
                        _vm.linkInfoTemp[_vm.linkInfoTemp.videoType].sources[0]
                          .src,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.linkInfoTemp[_vm.linkInfoTemp.videoType]
                            .sources[0],
                          "src",
                          $$v
                        )
                      },
                      expression:
                        "linkInfoTemp[linkInfoTemp.videoType].sources[0].src",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v(_vm._s(_vm.$t("panel.confirm")))]
                  ),
                  _c("el-button", { on: { click: _vm.onClose } }, [
                    _vm._v(_vm._s(_vm.$t("panel.cancel"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("i", {
        staticClass: "icon iconfont icon-chaolianjie",
        attrs: { slot: "reference" },
        slot: "reference",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }